/**
 * Safe localStorage wrappers that gracefully handle unavailability.
 * Used in private browsing, quota exceeded, or when storage is disabled.
 */

/**
 * Set an item in localStorage, silently failing if unavailable.
 * @returns true if successful, false if storage is unavailable
 */
export function safeLocalStorageSetItem(key: string, value: string): boolean {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

/**
 * Get an item from localStorage, returning null if unavailable.
 */
export function safeLocalStorageGetItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

/**
 * Remove an item from localStorage, silently failing if unavailable.
 * @returns true if successful, false if storage is unavailable
 */
export function safeLocalStorageRemoveItem(key: string): boolean {
  try {
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

/**
 * Clear all items from localStorage, silently failing if unavailable.
 * @returns true if successful, false if storage is unavailable
 */
export function safeLocalStorageClear(): boolean {
  try {
    localStorage.clear();
    return true;
  } catch {
    return false;
  }
}
